import { createSlice } from "@reduxjs/toolkit";
import { API_URL } from "../../../../constants";
import { GetServiceCaller } from "../../../../services/serviceCaller";

export const monthlyReportHandler = (pID, empType,monthID, employeeID) => async (dispatch) => {
  
  console.log('check monthID',employeeID);
  
    dispatch(setFetchingmonthlyReport(true));
     
    try {
      const response = await GetServiceCaller(
        `${API_URL}org-report/3?P_MonthID=${monthID || ""}&P_EmployeeID=${employeeID || ""}&P_ApplicationStatus=826`
      );
  
      console.log("checkResponse", response);
      if (response?.data) {
        dispatch(setmonthlyReportData(response.data));
      } else {
        dispatch(setmonthlyReportError("No Data Found"));
      }
    } catch (error) {
      dispatch(setmonthlyReportError(error.message));
    } finally {
      dispatch(setFetchingmonthlyReport(false));
    }
  };

const initialState = {
  apiStatus: 0,
  fetching: false,
  data: [],
  errors: "",
};

const monthlyReportSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    setmonthlyReportData: (state, action) => {
      state.apiStatus += 1;
      state.data = action.payload;
      state.errors = "";
    },
    setFetchingmonthlyReport: (state, action) => {
      state.fetching = action.payload;
    },
    setmonthlyReportError: (state, action) => {
      state.apiStatus += 1;
      state.data = [];
      state.errors = action.payload;
    },
  },
});

export const {
  setmonthlyReportData,
  setFetchingmonthlyReport,
  setmonthlyReportError,
} = monthlyReportSlice.actions;

export default monthlyReportSlice.reducer;
